export interface ApiResponse<T = unknown> {
  code: number;
  message: string;
  data: T;
  details?: unknown;
  requestId?: string | null;
  timestamp?: string;
}

export interface ApiErrorPayload {
  code: number;
  message: string;
  details?: unknown;
  requestId?: string | null;
  timestamp?: string;
  httpStatus?: number;
}

export class ApiRequestError extends Error {
  code: number;
  details?: unknown;
  requestId?: string | null;
  timestamp?: string;
  httpStatus?: number;

  constructor(payload: ApiErrorPayload) {
    super(payload.message || 'Request failed');
    this.name = 'ApiRequestError';
    this.code = payload.code;
    this.details = payload.details;
    this.requestId = payload.requestId;
    this.timestamp = payload.timestamp;
    this.httpStatus = payload.httpStatus;
  }
}

